/* tslint:disable:max-line-length */
import * as React from 'react';
import { MouseEvent } from 'react';
import { connect } from 'react-redux';
import { productInfoDeferred } from '../actions/Actions';
import { IProductInfo, IReferer, IState } from '../CustomTypes';
import { decode, doSpidLoginLinkWithRedirectToStart } from '../fastflowUtils';
import { svgCheck } from '../icons';
import { Button } from '../input-components/InputComponents';
import FooterSameLoginAsOthers from '../layout-components/FooterSameLoginAsOthers';
import './GotoSpid.scss';
import { sccPulseTrackPageView } from '../PulseUtils';

interface IGotoSpidProps {
  b64data?: string;
  email?: string;
  productInfo: IProductInfo;
  referer: IReferer;
  userCreated?: string;
}

export class ReceiptPage extends React.Component<IGotoSpidProps, {}> {
  constructor(props: IGotoSpidProps) {
    super(props);
    this.goToSpidLogin = this.goToSpidLogin.bind(this);
  }

  public componentDidMount() {
    productInfoDeferred.promise.then(product => {
      sccPulseTrackPageView(product, {}, 'To SPiD info page');
    });
  }

  public render() {
    let email = this.props.email;
    let userCreated = this.props.userCreated;
    if (this.props.b64data) {
      const base64data = decode(decodeURIComponent(this.props.b64data));
      if (base64data && base64data.email) {
        email = base64data.email;
      }
      if (base64data && base64data.userCreated) {
        userCreated = base64data.userCreated;
      }
    }
    const heading = userCreated ? 'Din konto er opprettet' : 'Du har en konto';
    return (
      <div className="gotospid">
        <div className="container">
          <h1>{svgCheck()}</h1>
          <h1>{heading}</h1>
          {userCreated && (
            <h4>Av sikkerhetsgrunner må du logge deg på en gang til.</h4>
          )}
          {!userCreated && (
            <h4>
              Logg inn med <span className="email">{email}</span> for å bestille
              abonnement
            </h4>
          )}
          <Button onClick={this.goToSpidLogin}>Logg deg inn</Button>
        </div>
        <FooterSameLoginAsOthers />
      </div>
    );
  }

  private goToSpidLogin(e: MouseEvent<HTMLAnchorElement>) {
    e.preventDefault();
    const { owningClient, productId, spidTeaser } = this.props.productInfo;
    let email = this.props.email;
    if (this.props.b64data) {
      const base64data = decode(decodeURIComponent(this.props.b64data));
      if (base64data && base64data.email) {
        email = base64data.email;
      }
    }
    doSpidLoginLinkWithRedirectToStart(
      owningClient,
      productId,
      email,
      spidTeaser
    );
  }
}

export default connect(
  (state: IState) =>
    ({
      b64data: state.router.location.query.b64data,
      email: state.router.location.query.email,
      productInfo: state.productInfo,
      referer: state.referer,
      userCreated: state.router.location.query.userCreated
    } as IGotoSpidProps)
)(ReceiptPage);



// WEBPACK FOOTER //
// ./src/page-components/GotoSpid.tsx